import { StringFormatter } from '@agoda/react-handyman';
import { CmsValue } from 'core/type/BootstrapConfig.types';

const half = 0.5;

const handleDays = (minutes: number): number => {
    const days = Math.floor(minutes / 1440);
    const remainder = Math.floor(minutes % 1440);
    if (remainder <= 0) {
        return days;
    }
    return remainder < 1440 / 2 ? days + half : days + 1;
};

const handleHour = (minutes: number): number => {
    const hours = Math.floor(minutes / 60);
    const remainder = Math.floor(minutes % 60);
    if (remainder <= 0) {
        return hours;
    }
    return remainder > 30 ? hours + 1 : hours + half;
};

const handleMinutes = (minutes: number): number => {
    const remainder = minutes % 10;
    return minutes + (remainder > 0 ? 10 - remainder : 0);
};

const getHourText = (hours: number, cms: CmsValue) => {
    if (hours > 23 && hours < 25) {
        return cms[126836];
    }
    return hours === 1 ? cms[126834] : cms[126833];
};

const getMinuteText = (minutes: number, cms: CmsValue) => {
    if (minutes === 60) {
        return cms[126834];
    }
    return minutes === 1 ? cms[126838] : cms[126837];
};

const formatText = (text: string, data?: string): string => StringFormatter.format(text, data || 0);

const roundUpDuration = (duration: number, cms: CmsValue): string => {
    if (duration >= 1440) {
        const days = handleDays(duration);
        const text = days === 1 ? cms[126836] : cms[126835];
        return formatText(text, days.toString());
    }
    if (duration > 60) {
        const hours = handleHour(duration);
        return formatText(getHourText(hours, cms), hours.toString());
    }
    const minutes = handleMinutes(duration);
    return formatText(getMinuteText(minutes, cms), minutes.toString());
};

export default roundUpDuration;
